import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="text-xl font-bold whitespace-nowrap cursor-pointer">
              皮皮漫画
            </Link>
            <p className="mt-3 text-sm text-background-50/70 leading-relaxed">
              专注日韩与国漫精品推荐，韩漫排行榜实时更新，日漫系列全集下拉畅读，国漫大图高清全彩。资源全面更新快，满足日韩控和国漫迷的追更需求。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">
              <Link to="/category/hanman" className="hover:text-background-50/80 transition-colors cursor-pointer">韩漫推荐</Link>
            </h4>
            <ul className="space-y-2 text-sm text-background-50/70">
              <li><Link to="/category/hanman" className="hover:text-background-50 transition-colors cursor-pointer">韩漫排行榜</Link></li>
              <li><Link to="/category/hanman" className="hover:text-background-50 transition-colors cursor-pointer">恋爱甜宠</Link></li>
              <li><Link to="/category/hanman" className="hover:text-background-50 transition-colors cursor-pointer">奇幻冒险</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">
              <Link to="/category/riman" className="hover:text-background-50/80 transition-colors cursor-pointer">日漫系列</Link>
            </h4>
            <ul className="space-y-2 text-sm text-background-50/70">
              <li><Link to="/category/riman" className="hover:text-background-50 transition-colors cursor-pointer">日漫全集</Link></li>
              <li><Link to="/category/riman" className="hover:text-background-50 transition-colors cursor-pointer">少年热血</Link></li>
              <li><Link to="/category/riman" className="hover:text-background-50 transition-colors cursor-pointer">搞笑日常</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">
              <Link to="/category/guoman" className="hover:text-background-50/80 transition-colors cursor-pointer">国漫精选</Link>
            </h4>
            <ul className="space-y-2 text-sm text-background-50/70">
              <li><Link to="/category/guoman" className="hover:text-background-50 transition-colors cursor-pointer">国漫大图</Link></li>
              <li><Link to="/category/guoman" className="hover:text-background-50 transition-colors cursor-pointer">玄幻修仙</Link></li>
              <li><Link to="/about" className="hover:text-background-50 transition-colors cursor-pointer">关于我们</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/20 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-background-50/60">
          <p>&copy; 2026 皮皮漫画网 - 皮皮漫画韩漫推荐与日漫系列 | 国漫大图下拉全彩追更</p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="hover:text-background-50 transition-colors cursor-pointer">关于我们</Link>
            <Link to="/" className="hover:text-background-50 transition-colors cursor-pointer">首页</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}